// Importar React y el hook useState desde la biblioteca 'react'
import React, { useState } from 'react';
import {  useNavigate } from "react-router-dom";
// Definición del componente funcional PredialForm
const PredialForm = ({ submitCallback }) => {
  // Definir estados locales para cada campo del formulario
  const [nombre, setNombre] = useState('');
  const [primerApellido, setPrimerApellido] = useState('');
  const [segundoApellido, setSegundoApellido] = useState('');
  const [razonSocial, setRazonSocial] = useState('');
  const [claveCatastral, setClaveCatastral] = useState('');
  const [processing] = useState(false); 
  const [error] = useState(null); 
  const navigate = useNavigate() 


  const handleSubmit = (e) => {
    e.preventDefault();
    const url= `/busqueda-predial?nombre=${nombre}&primerApellido=${primerApellido}&segundoApellido=${segundoApellido}&razonSocial=${razonSocial}&claveCastral=${claveCatastral}`
    navigate(url)
    
  };

  // Renderizar el formulario
  return (
    <form className="questionnaire" onSubmit={handleSubmit}>
      {/* Renderizar los campos del formulario */}
      <div className="question">
        <label>
          Nombre:
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Primer Apellido:
          <input type="text" value={primerApellido} onChange={(e) => setPrimerApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Segundo Apellido:
          <input type="text" value={segundoApellido} onChange={(e) => setSegundoApellido(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Razon Social:
          <input type="text" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Clave Catastral:
          <input type="text" value={claveCatastral} onChange={(e) => setClaveCatastral(e.target.value)} />
        </label>
      </div>
     {/* Botón de envío del formulario */}
     <button className='button2' type="submit" disabled={processing}>
        {processing ? 'Buscando...' : 'Buscar'}
      </button>

      {/* Mostrar mensaje de error si existe */}
      {error && <div className="error-message">{error}</div>}
    </form>
  );
};

// Exportar el componente PredialForm
export default PredialForm;
